// src/DynamicTitleAndFavicon.js

import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DynamicTitleAndFavicon = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    let title = "Travasco"; 
    let favicon = "/favicon2.ico"; 
    if (path === "/") {
      title = "Home - Travasco";
    } else if (path === "/HotelsList") {
      title = "Hotels List - Travasco";
    } else if (path === "/HotelDetails") {
      title = "Hotel Details - Travasco";
    }else if (path === "/FlightReservationTwo") {
      title = "Flight Booking - Travasco";
    }
    else if (path === "/FlightList") {
        title = "Flight List - Travasco";
    }

    document.title = title;
    const link = document.querySelector("link[rel='icon']");
    if (link) {
      link.href = favicon;
    }
  }, [location]);

  return null;
};

export default DynamicTitleAndFavicon;
